import { cn } from '@utils/cn';

import type { LoadingSpinnerProps } from '@types';

const LoadingSpinner = ({ size = 'md', fullScreen = false, className }: LoadingSpinnerProps) => {
  type SizeKey = NonNullable<LoadingSpinnerProps['size']>;
  const sizeClasses: Record<SizeKey, string> = {
    sm: 'w-6 h-6 border-2',
    md: 'w-10 h-10 border-3',
    lg: 'w-16 h-16 border-4',
  };
  const appliedSize: SizeKey = size ?? 'md';

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div
          role="status"
          className={cn(
            'border-gray-200 border-t-primary-600 rounded-full animate-spin',
            sizeClasses[appliedSize]
          )}
        >
          <span className="sr-only">Loading…</span>
        </div>
      </div>
    );
  }

  return (
    <div className={cn('flex items-center justify-center', className)}>
      <div
        role="status"
        className={cn(
          'border-gray-200 border-t-primary-600 rounded-full animate-spin',
          sizeClasses[appliedSize]
        )}
      >
        <span className="sr-only">Loading…</span>
      </div>
    </div>
  );
};

export default LoadingSpinner;
